module.exports = __webpack_public_path__ + "img/202304181108246235rt.815bbe71.jpg";